<h2 *ngIf="billingOrder" i18n> Review My Order </h2>
<h2 *ngIf="monthlyInvoice" i18n> Review My Order </h2>
<h2 *ngIf="payment" i18n> Review My Orders </h2>

<p-table styleClass="p-datatable-striped" *ngIf="leases" [columns]="tableColumns" [value]="leases">
  <ng-template pTemplate="header" let-columns>
    <tr *ngIf="leases.length > 0">
      <th [style.width.%]="col.width" *ngFor="let col of columns" class="noBorder" [ngClass]="col.field">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-lease let-columns="columns" let-index="rowIndex">
    <tr>
      <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field" [ngClass]="col.field">
        <div *ngSwitchDefault>{{ lease[col.field] }}</div>
        <div *ngSwitchCase="'term'">
          {{lease.term | termLength: lease.leaseType}}
        </div>
        <div *ngSwitchCase="'scId'">
          {{ lease[col.field] }} <span *ngIf="lease.ANString">({{lease?.ANString}})</span>
        </div>
        <div *ngSwitchCase="'price'">
          <span *ngIf="!lease.priceTBD">{{ lease[col.field] | currency }}</span>
          <span *ngIf="lease.priceTBD">To Be Determined</span>
        </div>
        <div *ngSwitchCase="'shortCodeType'">
          {{ lease.selectType }}
        </div>
        <div *ngSwitchCase="'discount'">
          <span *ngIf="!lease.priceTBD">
            {{ lease.discountList | discountSummary }} <span *ngIf="lease.discountAmount">({{
              lease.discountAmount | currency }}) </span>
          </span>
          <span *ngIf="lease.priceTBD">
            To Be Determined
          </span>
        </div>
        <div *ngSwitchCase="'listPrice'">
          {{ lease.listPrice | currency }}
        </div>
        <div class="align-top" *ngSwitchCase="'autoRenew'">
          <p-checkbox (onChange)="autoRenewChecked(lease)" name="autoRenew{{index}}" [(ngModel)]="lease.autorenew" [binary]="true"></p-checkbox>
        </div>
        <div class="align-top" *ngSwitchCase="'addToMonthlyBilling'">
          <p-checkbox *ngIf="lease.applicationType !== 'Renew'" (onChange)="addToMbChecked(lease)" name="addToMb{{index}}" [(ngModel)]="lease.addToMb" [binary]="true"></p-checkbox>
          <span *ngIf="lease.applicationType === 'Renew'">N/A</span>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length" class="noBorder" style="background-color: #EEF7F7;">
        <p><small>You don't have any codes in your cart yet. <br> Use the Add Codes section below to add
            codes to your cart.</small></p>
      </td>
    </tr>
  </ng-template>
</p-table>

<h5>
  <b>Total: {{ totalPrice | currency }}</b>
</h5>
<h5 *ngIf="applyCredit === true">
  <b><span>Credit:</span> ({{creditToBeApplied | currency}}) <span>Credit on Account will be applied to this payment</span></b>
</h5>
<h5 *ngIf="applyCredit === true">
  <b><span>Amount Due:</span> {{amountDueAfterCredit | currency}} </b>
</h5>
<small *ngIf="creditAmount > 0 && applyCredit === false">
  Your account has credit in the amount of {{ creditAmount | currency }}.<br />
  To pay using this credit, select Apply Credit on Account, below.
</small>